// utils/dateUtils.js
export const formatDateForApi = (date) => {
  if (!date) return "";
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const getDefaultDates = () => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);
  
  return {
    startDate: formatDateForApi(sevenDaysAgo),
    endDate: formatDateForApi(yesterday)
  };
};

export const formatDisplayDate = (dateStr) => {
  if (!dateStr) return "";
  
  if (dateStr.includes('-')) {
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const year = parts[0];
      const month = parts[1];
      const day = parts[2];
      return `${day}/${month}`;
    }
  }
  
  if (dateStr.includes('/')) {
    const parts = dateStr.split('/');
    if (parts.length === 3) {
      const day = parts[0];
      const month = parts[1];
      return `${day}/${month}`;
    }
  }
  
  return dateStr;
};

export const extractTime = (dateTimeStr) => {
  if (!dateTimeStr) return '';
  const parts = dateTimeStr.split('T');
  if (parts.length < 2) return '';
  const timePart = parts[1];
  return timePart.substring(0, 8);
};

export const validateDate = (dateStr) => {
  if (!dateStr) return false;
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  if (!regex.test(dateStr)) return false;
  const [day, month, year] = dateStr.split('/').map(Number);
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

export const toLocalDate = (utcDateString) => {
  if (!utcDateString) return null;
  return new Date(utcDateString + 'Z');
};

export const formatLocalHour = (utcDateString) => {
  if (!utcDateString) return 'N/A';
  const date = new Date(utcDateString + 'Z');
  const hours = date.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 || 12;
  return `${hour12} ${ampm}`;
};

export const formatLocalTime = (utcDateString) => {
  if (!utcDateString) return 'N/A';
  const date = new Date(utcDateString + 'Z');
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const formatLocalDateTime = (utcDateString) => {
  if (!utcDateString) return 'N/A';
  const date = new Date(utcDateString + 'Z');
  return date.toLocaleString();
};